import { render, staticRenderFns } from "./CommessaElementi.vue?vue&type=template&id=1cbeb6b4&scoped=true&"
import script from "./CommessaElementi.vue?vue&type=script&lang=js&"
export * from "./CommessaElementi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbeb6b4",
  null
  
)

export default component.exports